import { gql } from "@apollo/client";

// Today / Roster / service reports / invoices. All scoped server-side to the
// logged-in customer (from the auth token) - there's deliberately no customerId
// variable. from/to are ISO instants of the browser's own day boundaries.

export const getCustomerPortalTodayQuery = gql`
query($from: String!, $to: String!){
  getCustomerPortalToday(from: $from, to: $to) {
    message
    response
  }
}
`;

export const getCustomerPortalRosterQuery = gql`
query($from: String!, $to: String!, $siteId: String){
  getCustomerPortalRoster(from: $from, to: $to, siteId: $siteId) {
    message
    response
  }
}
`;

// source: 'schedule' | 'mobileService'
export const getCustomerPortalDutyProofQuery = gql`
query($source: String!, $id: String!){
  getCustomerPortalDutyProof(source: $source, id: $id) {
    message
    response
  }
}
`;

export const getCustomerPortalServiceSummaryQuery = gql`
query($from: String!, $to: String!, $siteId: String){
  getCustomerPortalServiceSummary(from: $from, to: $to, siteId: $siteId) {
    message
    response
  }
}
`;

export const getCustomerPortalInvoicesQuery = gql`
query{
  getCustomerPortalInvoices {
    message
    response
  }
}
`;

export const getCustomerPortalInvoiceQuery = gql`
query($id: String!){
  getCustomerPortalInvoice(id: $id) {
    message
    response
  }
}
`;
